import axios from "axios";
export var fetchPolizaPayment = function fetchPolizaPayment(id) {
  return axios.get("/api/v1/poliza_payments/".concat(id), {
    timeout: 5000
  }).then(function (response) {
    return response.data;
  })["catch"](function (error) {
    if (error.code === 'ECONNABORTED' || error.response && error.response.status === 500) {
      throw new Error("Error al obtener el pago");
    }

    throw error;
  });
};
export var updatePolizaPayment = function updatePolizaPayment(poliza_payment, token) {
  var cleanData = {}; // Solo incluir campos si están definidos (undefined significa "no cambiar")

  if (poliza_payment.due_date !== undefined) {
    cleanData.due_date = poliza_payment.due_date || null;
  }

  if (poliza_payment.amount !== undefined) {
    cleanData.amount = poliza_payment.amount;
  }

  if (poliza_payment.payment_received_at !== undefined) {
    cleanData.payment_received_at = poliza_payment.payment_received_at || null;
  }

  var headers = {
    "Content-Type": "application/json",
    "Accept": "application/json"
  };

  if (token) {
    headers["X-CSRF-Token"] = token;
  } else {
    // Obtener token del meta tag si no se proporciona
    var metaToken = document.querySelector('meta[name="csrf-token"]');

    if (metaToken) {
      headers["X-CSRF-Token"] = metaToken.getAttribute("content");
    }
  }

  return axios.put("/api/v1/poliza_payments/".concat(poliza_payment.id), {
    poliza_payment: cleanData
  }, {
    headers: headers
  }).then(function (response) {
    return response;
  });
};